module.exports = __webpack_public_path__ + "img/slogan.850ab460.webp";